enum StatusDiscenteEnum {
  ATIVO = 1,
  TRANCADO = 5,
  FORMANDO = 8,
}

export default StatusDiscenteEnum;
